// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:1000px){.reloadNewsFlash[data-v-446f24ed]{margin-left:24%;cursor:pointer;font-size:smaller;color:#0d3cbf;text-decoration:underline;text-underline-position:under}}@media screen and (max-width:1000px){.reloadNewsFlash[data-v-446f24ed]{margin-left:6%;cursor:pointer;font-size:smaller;color:#0d3cbf;text-decoration:underline;text-underline-position:under}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
